import React, { useEffect, useState } from "react";
import CDropdown from "../../common/CDropdown";
import CommonMessage from "../../common/CommonMessage";
import { GetAllProduct } from "../../services/productService";
import { AddInventry } from "../../services/inventory";

const AddInventory = () => {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [products, setProducts] = useState([]);

    const [formData, setFormData] = useState({
        productId: "",
        openingStock: "",
        referenceNo: "",
        remarks: "",
    });

    useEffect(() => {
        loadProducts();
    }, []);

    const loadProducts = async () => {
        try {
            const response = await GetAllProduct();
            if (response?.success) {
                setProducts(response.data);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const payload = {
            productId: Number(formData.productId),
            openingStock: Number(formData.openingStock),
            referenceNo: formData.referenceNo,
            remarks: formData.remarks,
        };

        try {
            console.log(payload);

             const response = await AddInventry(payload);
console.log("add",response);
            if(response.success){
                setMessage("Inventory added successfully.");
            }
        } catch (error) {
            setMessage("Something went wrong.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-fluid py-3">
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-lg-6">
                        <div className="custom-card">
                            <div className="card-header-red">
                                Add Inventory
                            </div>

                            <div className="card-body-custom">

                                {/* Product */}
                                <div className="mb-3">
                                    <label className="form-label">
                                        Product
                                    </label>

                                    <CDropdown
                                        name="productId"
                                        value={formData.productId}
                                        options={products}
                                        optionLabel="name"
                                        optionValue="id"
                                        onChange={handleChange}
                                        firstOption="Select Product"
                                    />
                                </div>

                                {/* Opening Stock */}
                                <div className="mb-3">
                                    <label className="form-label">
                                        Opening Stock
                                    </label>

                                    <input
                                        type="number"
                                        className="form-control"
                                        name="openingStock"
                                        value={formData.openingStock}
                                        onChange={handleChange}
                                        placeholder="Enter Opening Stock"
                                    />
                                </div>

                                {/* Reference No */}
                                <div className="mb-3">
                                    <label className="form-label">
                                        Reference No
                                    </label>

                                    <input
                                        type="text"
                                        className="form-control"
                                        name="referenceNo"
                                        value={formData.referenceNo}
                                        onChange={handleChange}
                                        placeholder="Enter Reference No"
                                    />
                                </div>

                                {/* Remarks */}
                                <div className="mb-3">
                                    <label className="form-label">
                                        Remarks
                                    </label>

                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        name="remarks"
                                        value={formData.remarks}
                                        onChange={handleChange}
                                        placeholder="Enter Remarks"
                                    />
                                </div>

                                <button
                                    type="submit"
                                    className="btn btn-success"
                                    disabled={loading}
                                >
                                    {loading ? "Submitting..." : "Submit"}
                                </button>

                            </div>
                        </div>

                        {message && <CommonMessage text={message} />}
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AddInventory;